import {fetch} from "utils/dataAccess";

export default function create(quote, comment) {
    const body = {
        quote: quote,
        comment: comment
    }

    return new Promise((resolve, reject) => {
        fetch(`/quote_comments`, {
            method: 'POST',
            body: JSON.stringify(body)
        })
        .then(response => {
            response.json().then(response => {
                resolve(response);
            });
        })
        .catch(error => reject(error));
    });
}
